"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uuid = require("uuid");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// This code has been copied over from https://github.com/szchenghuang/react-google-invisible-recaptcha
// and edited so that requests are sent to www.recaptcha.net instead of www.google.com

var DEFAULT_RECAPTCHA_HOSTNAME = 'www.recaptcha.net';
var renderers = [];
var injectScript = function injectScript(locale, nonce) {
  var recaptchaHostName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_RECAPTCHA_HOSTNAME;
  window.GoogleRecaptchaLoaded = function () {
    while (renderers.length) {
      var renderer = renderers.shift();
      renderer();
    }
  };
  var script = document.createElement('script');
  script.async = true;
  script.defer = true;
  script.id = 'recaptcha';
  script.onerror = function (error) {
    throw error;
  };
  script.src = "https://".concat(recaptchaHostName, "/recaptcha/api.js?").concat(locale && 'hl=' + locale, "&onload=GoogleRecaptchaLoaded&render=explicit");
  script.type = 'text/javascript';
  nonce && script.setAttribute('nonce', nonce);
  document.body.appendChild(script);
};
var GoogleRecaptcha = /*#__PURE__*/function (_React$Component) {
  function GoogleRecaptcha() {
    _classCallCheck(this, GoogleRecaptcha);
    return _callSuper(this, GoogleRecaptcha, arguments);
  }
  _inherits(GoogleRecaptcha, _React$Component);
  return _createClass(GoogleRecaptcha, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;
      var _this$props = this.props,
        badge = _this$props.badge,
        locale = _this$props.locale,
        nonce = _this$props.nonce,
        onExpired = _this$props.onExpired,
        onError = _this$props.onError,
        onLoaded = _this$props.onLoaded,
        onResolved = _this$props.onResolved,
        sitekey = _this$props.sitekey,
        tabindex = _this$props.tabindex;
      this.callbackName = 'GoogleRecaptchaResolved-' + (0, _uuid.v4)();
      window[this.callbackName] = onResolved;
      var loaded = function loaded() {
        if (_this.container) {
          var wrapper = document.createElement('div');
          // This wrapper must be appended to the DOM immediately before rendering
          // reCaptcha. Otherwise multiple reCaptchas will act jointly somehow.
          _this.container.appendChild(wrapper);
          var recaptchaId = window.grecaptcha.render(wrapper, {
            badge: badge,
            callback: _this.callbackName,
            'error-callback': onError,
            'expired-callback': onExpired,
            sitekey: sitekey,
            size: 'invisible',
            tabindex: tabindex
          });
          _this.execute = function () {
            return window.grecaptcha.execute(recaptchaId);
          };
          _this.reset = function () {
            return window.grecaptcha.reset(recaptchaId);
          };
          _this.getResponse = function () {
            return window.grecaptcha.getResponse(recaptchaId);
          };
          onLoaded();
        }
      };
      if (window.grecaptcha && window.grecaptcha.render && window.grecaptcha.execute && window.grecaptcha.reset && window.grecaptcha.getResponse) {
        loaded();
      } else {
        renderers.push(loaded);
        if (!document.querySelector('#recaptcha')) {
          injectScript(locale, nonce);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      while (this.container.firstChild) {
        this.container.removeChild(this.container.firstChild);
      }
      // There is a chance that the reCAPTCHA API lib is not loaded yet, so check
      // before invoking reset.
      if (this.reset) {
        this.reset();
      }
      delete window[this.callbackName];
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var style = this.props.style;
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: function ref(_ref) {
          return _this2.container = _ref;
        }
      }, style && {
        style: style
      }));
    }
  }]);
}(_react["default"].Component);
GoogleRecaptcha.propTypes = {
  badge: _propTypes["default"].oneOf(['bottomright', 'bottomleft', 'inline']),
  locale: _propTypes["default"].string,
  nonce: _propTypes["default"].string,
  onExpired: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onResolved: _propTypes["default"].func,
  onLoaded: _propTypes["default"].func,
  sitekey: _propTypes["default"].string.isRequired,
  style: _propTypes["default"].object,
  tabindex: _propTypes["default"].number
};
GoogleRecaptcha.defaultProps = {
  badge: 'bottomright',
  locale: '',
  onExpired: function onExpired() {
    return undefined;
  },
  onError: function onError() {
    return undefined;
  },
  onLoaded: function onLoaded() {
    return undefined;
  },
  onResolved: function onResolved() {
    return undefined;
  },
  tabindex: 0
};
var _default = exports["default"] = GoogleRecaptcha;
//# sourceMappingURL=index.js.map